import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { BubbleButtonProps } from '../../../client/components/BubbleUI/BubbleButton';

export enum ExtensionPointNamespace {
  UI_MENU = 'go.ui.menu',
}

export type ExtensionPointProps = {
  namespace: ExtensionPointNamespace;
  events?: any;
  data?: any;
};

// move to shared
interface MenuBarBadge {
  key: string;
  number: number;
  variant: 'crimson' | 'navy';
}

interface MenuBarIconBase {
  key: string;
  icon?: IconProp;
  badges?: MenuBarBadge[];
  title?: React.ReactNode;
}

interface MenuBarLinkIcon {
  type: 'link';
  buttonProps?: BubbleButtonProps;
}

export type UIMenuContribution = MenuBarIconBase & MenuBarLinkIcon;

export type MainMenuExtension = {
  namespace: ExtensionPointNamespace.UI_MENU;
  contribution: UIMenuContribution;
};

export type Extension = MainMenuExtension;
